export default "__VITE_ASSET__G5dgqDQf__"